<script>
import AgeCategories from "../../AgeCategories/AgeCategories.vue";
import ApiPostButton from "../Buttons/ApiPostButton.vue";
import BlockRenderer from "../../Common/BlockRenderer.vue";
import datePicker from 'vue-bootstrap-datetimepicker';
import Ckeditor from 'vue-ckeditor2';
import CollapseButton from "../Buttons/CollapseButton.vue";
import { dateTimeFormat } from '../filters/dates';
import EntitySelectInput from "../Forms/InputFields/EntitySelectInput.vue";
import GroupedCheckboxList from "../../AAA_TO_REFACTOR/CheckboxComponents/GroupedCheckboxList.vue";
import InputWrapper from "../Forms/InputWrapper.vue";
import MemberSearch from "../../AAA_TO_REFACTOR/MemberSearch.vue";
import ModalHeading from '../../AAA_TO_REFACTOR/Bootstrap/BootstrapVersionFixers/ModalHeading/ModalHeading.vue';
import MoneyInput from "../Forms/InputFields/MoneyInput.vue";
import DateField from "../Forms/InputFields/DateField.vue";
import PhoneInput from "../Forms/InputFields/PhoneInput.vue";
import SelectInput from "../Forms/InputFields/SelectInput.vue";
import SimpleBoolean from "./SimpleBoolean.vue";
import ThemeSelect from "../../TenantConfigurations/ThemeSelect.vue";
import PrePayInviter from "../../Participants/PrePayInviter.vue";
import CopyToClipboard from "../Buttons/CopyToClipboard.vue";
import SaveParticipantProfileToggleButton from "../../Participants/SaveParticipantProfileToggleButton.vue";

export default {
    name: 'ValueStorage',

    components: {
        AgeCategories,
        ApiPostButton,
        BlockRenderer,
        Ckeditor,
        CollapseButton,
        DatePicker: datePicker,
        DateField,
        EntitySelectInput,
        GroupedCheckboxList,
        InputWrapper,
        MemberSearch,
        ModalHeading,
        MoneyInput,
        PhoneInput,
        SelectInput,
        SimpleBoolean,
        ThemeSelect,
        PrePayInviter,
        CopyToClipboard,
        SaveParticipantProfileToggleButton,
    },

    filters: {
        dateTimeFormat,
    },

    props: {
        defaultValue: {
            required: true,
            type: Object,
        },
    },

    data() {
        return {
            valueStorageValue: JSON.parse(JSON.stringify(this.defaultValue)),
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/InlineTemplates/ValueStorage.vue